<template>
  <div>
    <!-- 顶部大图 -->
    <div
        class="top_img"
        :style="{
        'background-image':  `url(${topBannerData.img})`
      }"
    >
      <p class="title">{{ topTitle }}</p>
      <p class="subtitle">{{ topSubtitle }}</p>
    </div>

    <!-- 公司简介 -->
    <div class="about_container">
      <section id="CompanyProfile" class="company_intro">
        <div class="intro_content intro_content2">
          <div class="image_side">
            <div class="image_placeholder" v-if="!aboutUsData.image1">
              <i class="el-icon-office-building"></i>
            </div>
            <img v-else :src="aboutUsData.image1" alt="Company Image" class="company_image" />
          </div>
          <div class="text_side">
            <p class="h2">{{ aboutUsData.title1 }}</p>
            <p class="intro_text">{{ aboutUsData.content1 }}</p>

            <div class="stats_row">
              <img v-if="aboutUsData.statsImage" :src="aboutUsData.statsImage" alt="Stats" class="stats_image" />
            </div>
          </div>

        </div>
      </section>
      <section class="company_intro">
        <div class="intro_content">
          <div class="text_side">
            <p class="h2">{{ aboutUsData.title2 }}</p>
            <p class="intro_text">{{ aboutUsData.content2 }}</p>
          </div>
          <div class="image_side">
            <div class="image_placeholder" v-if="!aboutUsData.image2">
              <i class="el-icon-office-building"></i>
            </div>
            <img v-else :src="aboutUsData.image2" alt="Company Image" class="company_image" />
          </div>
        </div>
      </section>
      <!-- 组织架构 -->
      <section class="company_intro" id="OrganizationalStructure" >
        <div class="intro_content">
          <div class="image_side3">
            <div class="image_placeholder" v-if="!aboutUsData.image3">
              <i class="el-icon-office-building"></i>
            </div>
            <img v-else :src="aboutUsData.image3" alt="Company Image" class="company_image" />
          </div>
        </div>
      </section>

      <!-- 我们的部门 -->
      <section id="OurDepartment" class="company_culture gray_bg" :style="{ 'background-image': 'url(http://jw-imgs.oss-cn-hangzhou.aliyuncs.com/file/20260317/zZDjtjhepPt33Zi7YJkyPMTmhrQtNPKX/%E7%BB%84%202851%402x.png)' }">
        <div class="culture_content">
          <p class="h2">{{ $t("Our Department") }}</p>
            <AboutSwiper6></AboutSwiper6>
        </div>
      </section>

      <!-- 发展历程 -->
      <section id="Milestone" class="company_history">
        <div class="history_content">
          <p class="h2">{{ $t("发展历程") }}</p>
          <MilestoneSwiper :milestone-list="milestoneList" />
        </div>
      </section>

      <!-- 荣誉资质 -->
      <section id="CertificatesAndHonors" class="company_honors gray_bg">
        <div class="honors_content">
          <p class="h2">{{ $t("荣誉资质") }}</p>
          <div class="honors_grid">
            <div class="honor_item" v-for="(item, index) in honorList" :key="index">
              <img v-if="item.image" :src="item.image" alt="Honor" class="honor_image" />
              <i v-else class="el-icon-medal"></i>
              <p v-if="item.title">{{ item.title }}</p>
            </div>
          </div>
          <AboutSwiper7 :honor-list="honorList"></AboutSwiper7>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/index";
import AboutSwiper1 from "@/components/view/AboutSwiper1.vue";
import AboutSwiper2 from "@/components/view/AboutSwiper2.vue";
import AboutSwiper3 from "@/components/view/AboutSwiper3.vue";
import AboutSwiper4 from "@/components/view/AboutSwiper4.vue";
import AboutSwiper5 from "@/components/view/AboutSwiper5.vue";
import AboutSwiper7 from "./view/AboutSwiper7.vue";
import AboutSwiper6 from "./view/AboutSwiper6.vue";
import MilestoneSwiper from "./view/MilestoneSwiper.vue";

export default {
  components: {MilestoneSwiper, AboutSwiper6, AboutSwiper7, AboutSwiper5, AboutSwiper4, AboutSwiper3, AboutSwiper2, AboutSwiper1},
  data() {
    return {
      isMiniWindows: false,
      clientWidth: 0,
      contactData: {},
      aboutUsData: {},
      milestoneList: [],
      honorList: [],
      topBannerData: {},
      dataLoaded: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.$nextTick(() => {
      const tag = to.query.param;
      if (tag) {
        const element = document.getElementById(tag);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  },
  computed: {
    topTitle() {
      if (this.$i18n.locale === 'zh') {
        return this.topBannerData.titleZh || "";
      } else if (this.$i18n.locale === 'es') {
        return this.topBannerData.titleEs || this.topBannerData.titleEn || "";
      }
      return this.topBannerData.titleEn || "";
    },
    topSubtitle() {
      if (this.$i18n.locale === 'zh') {
        return this.topBannerData.contentZh || "";
      } else if (this.$i18n.locale === 'es') {
        return this.topBannerData.contentEs || this.topBannerData.contentEn || "";
      }
      return this.topBannerData.contentEn || "";
    }
  },
  watch: {
    clientWidth(newVal) {
      this.isMiniWindows = newVal < 1200;
    },
  },
  mounted() {
    Promise.all([
      this.getTopBannerData(),
      this.getContactUsData(),
      this.getAboutUsData(),
      this.getMilestoneData()
    ]).then(() => {
      this.dataLoaded = true;
      this.scrollToSection();
    });

    let that = this;
    var clientWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },
  methods: {
    scrollToSection() {
      this.$nextTick(() => {
        setTimeout(() => {
          const tag = this.$route.query.param;
          if (tag) {
            const element = document.getElementById(tag);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }, 100);
      });
    },
    // 获取顶部Banner数据
    getTopBannerData() {
      return API.getTopImgsByRemark('关于')
        .then((res) => {
          console.log('topBannerData res',res);
          if (res.code === 0 && res.topImgs) {
            this.topBannerData = res.topImgs;
          }
        })
        .catch(() => {});
    },
    // 获取联系我们信息
    getContactUsData() {
      return API.getContactUsList({ page: 1, limit: 1 })
        .then((res) => {
          if (res.code === 0 && res.page && res.page.list && res.page.list.length > 0) {
            const data = res.page.list[0];
            this.contactData = {
              topImage: data.topImage || "",
              topTitleCn: data.topTitleCn || "",
              topTitleEn: data.topTitleEn || "",
              topTitleEs: data.topTitleEs || ""
            };
          }
        })
        .catch(() => {});
    },
    // 获取关于我们数据
    getAboutUsData() {
      return API.getAboutUsList({page: 1, limit: 3})
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list && res.page.list.length > 0) {
              const list = res.page.list;
              const locale = this.$i18n.locale;

              // 获取统计图片（根据语言选择）
              const getStatsImage = (item) => {
                if (locale === 'zh') return this.isMiniWindows?item?.smallImage1Phone:item?.smallImage1 || '';
                if (locale === 'es') return this.isMiniWindows?item?.smallImage3Phone:item?.smallImage3 || '';
                return this.isMiniWindows?item?.smallImage2Phone:item?.smallImage2 || '';
              };

              // 将3个item分别映射到3个section
              this.aboutUsData = {
                // 第一个section
                image1: list[0]?.bigImage || '',
                statsImage: getStatsImage(list[0]),
                title1: this.$getI18nField(list[0], 'title'),
                content1: this.$getI18nField(list[0], 'intro'),

                // 第二个section
                image2: list[1]?.bigImage || '',
                title2: this.$getI18nField(list[1], 'title'),
                content2: this.$getI18nField(list[1], 'intro'),

                // 第三个section
                image3: getStatsImage(list[2])
              };
            }
          })
          .catch(() => {
          });
    },
    // 获取发展历程数据
    getMilestoneData() {
      return API.getMilestoneBannerList({page: 1, limit: 10})
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list) {
              // 转换多语言字段
              this.milestoneList = this.$transformI18nList(
                res.page.list,
                ['title', 'content']
              );
            }
          })
          .catch(() => {
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.top_img {
  padding:0 12.5%;
  height: 47rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .title {
    text-align: left;
    font-size: 7rem;
    font-family: bold;
    color: white;
    margin: 16rem 0 0 0;
    align-self: flex-start;
  }

  .subtitle {
    width:40%;
    text-align: left;
    font-size: 2.4rem;
    color: #E7E8EA;
    margin-top: 1rem;
    line-height: 3.6rem;
  }
}

.about_container {
  section {
    padding: 8rem 0;

    &.gray_bg {
      background: #f8f8f8;
    }

    .h2 {
      font-size: 3.6rem;
      color: $color2C;
      text-align: center;
      margin-bottom: 5rem;
    }
  }
}

.company_intro {
  padding: 17rem 0 8rem !important;

  .intro_content {
    margin: 0 12.5%;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 13rem;

    .text_side {
      height: 52rem;
      flex: 1;

      .h2 {
        font-family: bold;
        font-size: 5rem;
        color: #212121;
        text-align: left;
        margin:0 0 3rem 0;
      }

      .intro_text {
        font-family: regular;
        font-size: 2.2rem;
        color: #5B6370;
        line-height: 3rem;
        margin-bottom: 1rem;
        text-align: left;
      }

      .stats_row {
        display: flex;
        gap: 5rem;
        margin-top: 0;

        img{
          width: 100%;
        }

        .stat_item {
          display: flex;
          flex-direction: column;

          .number {
            font-size: 4rem;
            font-weight: bold;
            color: $textBlueColor;
          }

          .label {
            font-size: 1.4rem;
            color: $color5E;
            margin-top: 0.5rem;
          }
        }
      }
    }

    .image_side3{
      width: 100%;
      height: auto;
      object-fit: contain;
      img{
        width: 100%;
        height: auto;
      }
    }
    .image_side {
      flex: 1.2;

      .company_image {
        width: 100%;
        height: 52rem;
        object-fit: cover;
        border-radius: 1rem;
      }

      .image_placeholder {
        height: 40rem;
        background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
        border-radius: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 12rem;
          color: $textBlueColor;
          opacity: 0.5;
        }
      }
    }
  }
}

.company_culture {
  box-sizing: border-box;
  padding: 0;
  .culture_content {
    margin: 0;
    padding: 3rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    .h2{
      margin: 0 12.5%;
      font-size:5rem;
      font-family: bold;
      color: white;
      text-align: left;
    }

    .culture_grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 4rem;

      .culture_item {
        text-align: center;
        padding: 4rem 3rem;
        background: white;
        border-radius: 1rem;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

        .icon {
          width: 8rem;
          height: 8rem;
          background: rgba(25, 97, 172, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;

          i {
            font-size: 3.5rem;
            color: $textBlueColor;
          }
        }

        h3 {
          font-size: 2rem;
          color: $color2C;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1.5rem;
          color: $color5E;
          line-height: 1.6;
        }
      }
    }
  }
}

.company_history {
  .history_content {
    margin: 0 12.5%;
    padding: 0;

    .h2{
      margin: 0;
      font-size:5rem;
      font-family: bold;
      color: #212121;
      text-align: left;
    }
  }
}

.company_honors {
  padding-bottom: 15rem !important;
  .honors_content {
    margin: 0 12.5%;
    padding: 0;
    .h2{
      margin: 0;
      font-size:5rem;
      font-family: bold;
      color: #212121;
      text-align: left;
    }

    .honors_grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 3rem;

      .honor_item {
        background: white;
        padding: 3rem;
        border-radius: 1rem;
        text-align: center;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }

        .honor_image {
          width: 100%;
          height: 15rem;
          object-fit: contain;
          margin-bottom: 1.5rem;
        }

        i {
          font-size: 4rem;
          color: $textBlueColor;
          margin-bottom: 1.5rem;
        }

        p {
          font-size: 1.6rem;
          color: $color2C;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .top_img {
    height: 30rem;

    .title {
      font-size: 3.5rem;
    }

    .subtitle {
      font-size: 1.4rem;
      letter-spacing: 0.5rem;
    }
  }

  .about_container {
    section {
      padding: 4rem 0;

      .h2 {
        font-size: 2.8rem;
        margin-bottom: 3rem;
      }
    }
  }

  .company_intro {
    .intro_content {
      flex-direction: column;
      gap: 3rem;

      .text_side {
        .h2 {
          text-align: center;
        }

        .stats_row {
          justify-content: center;
        }
      }

      .image_side {
        width: 100%;

        .company_image {
          height: 25rem;
        }

        .image_placeholder {
          height: 25rem;

          i {
            font-size: 8rem;
          }
        }
      }
    }
  }

  .company_culture {
    .culture_content {
      .culture_grid {
        grid-template-columns: 1fr;
      }
    }
  }

  .company_honors {
    .honors_content {
      .honors_grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}

@media (max-width: 768px) {
  .top_img {
    padding: 0 2rem;
    height: 30rem;
    display: flex;

    .title {
      font-size: 3rem;
      margin: 5rem 0 0 0;
    }

    .subtitle {
      width: 80%;
      font-size: 1.4rem;
      margin-top: 1rem;
      line-height: 1.5;
      letter-spacing:0;
    }
  }

  .about_container {
    section {
      padding: 4rem 0;

      .h2 {
        font-size: 2.5rem;
        margin-bottom: 2rem;
      }
    }
  }

  .company_intro {
    padding: 8rem 0 0 !important;

    .intro_content {
      margin: 0 2rem;
      display: flex;
      gap: 2rem;

      .text_side {
        height: auto;

        .h2 {
          font-size: 2.8rem;
          margin: 0 0 2rem 0;
          text-align: left;
        }

        .intro_text {
          font-size: 1.6rem;
          line-height: 2.4rem;
          margin-bottom: 1rem;
        }

        .stats_row {
          margin-top: 2rem;
          gap: 2rem;
        }
      }

      .image_side {
        .company_image {
          height: 30rem;
        }

        .image_placeholder {
          height: 30rem;
        }
      }
    }
    .intro_content2{
      flex-direction: column-reverse;
    }
  }

  .company_culture {
    .culture_content {
      padding: 2rem 0;

      .h2 {
        margin: 0 2rem;
        font-size: 2.8rem;
      }
    }
  }

  .company_history {
    .history_content {
      margin: 0 2rem;

      .h2 {
        font-size: 2.8rem;
      }
    }
  }

  .company_honors {
    padding-bottom: 8rem !important;

    .honors_content {
      margin: 0 2rem;

      .h2 {
        font-size: 2.8rem;
      }

      .honors_grid {
        grid-template-columns: 1fr;
        gap: 2rem;

        .honor_item {
          padding: 2rem;

          .honor_image {
            height: 12rem;
            margin-bottom: 1rem;
          }

          p {
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
</style>

